import PageHero from "../components/PageHero";
import { SCHOOL } from "../lib/site";
import { Heart, Target, Sparkles, GraduationCap } from "lucide-react";

const VALUES = [
  { icon: Heart, title: "Passione", text: "La musica come linguaggio universale, vissuta con dedizione." },
  { icon: Target, title: "Eccellenza", text: "Un percorso didattico rigoroso fondato su standard internazionali." },
  { icon: Sparkles, title: "Creatività", text: "Spazio all'espressione personale e all'interpretazione." },
  { icon: GraduationCap, title: "Certificazione", text: "Riconoscimenti ufficiali Trinity College London." },
];

export default function ChiSiamo() {
  return (
    <div data-testid="page-chi-siamo">
      <PageHero
        eyebrow="Chi Siamo"
        title="Amici per la Musica APS,"
        italic={`dal ${SCHOOL.founded} al servizio dell'arte.`}
        subtitle="Associazione di Promozione Sociale dedicata alla diffusione della cultura musicale e delle performing arts attraverso un'offerta didattica di alto profilo."
      />

      <section className="py-24 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <div className="text-[11px] tracking-eyebrow text-[#A3133A] mb-4">La nostra storia</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1C1C1C] leading-tight">
              Una scuola, una<br />comunità di artisti.
            </h2>
          </div>
          <div className="md:col-span-7 text-[#5C5C5C] leading-relaxed space-y-5 text-base sm:text-lg">
            <p>
              <strong className="text-[#1C1C1C]">Amici per la Musica APS</strong> nasce
              dalla volontà di musicisti e didatti del territorio di creare uno
              spazio educativo dove il rigore della tradizione conservatoriale
              dialoga con l'apertura ai linguaggi contemporanei. Operiamo tra
              le province di <strong className="text-[#1C1C1C]">Ferrara</strong> e
              {" "}<strong className="text-[#1C1C1C]">Rovigo</strong> con tre sedi
              didattiche.
            </p>
            <p>
              La <em>Trinity Musical School</em> rappresenta il braccio didattico
              dell'associazione: una scuola di musica e spettacolo accreditata
              come centro ufficiale di esami <strong>Trinity College London</strong>
              {" "}(Centre Registration Number {SCHOOL.trinityCentreId}).
            </p>
            <p>
              Offriamo percorsi individuali e collettivi per allievi di ogni età,
              dalla propedeutica musicale ai corsi avanzati, con la possibilità
              di sostenere gli esami di certificazione internazionale Trinity
              direttamente presso la nostra sede.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#A3133A]/15 border border-[#A3133A]/15">
          {VALUES.map((v, i) => (
            <div key={v.title} className="bg-[#FBFBF9] p-8" data-testid={`value-${i}`}>
              <v.icon size={24} className="text-[#A3133A] mb-5" />
              <div className="font-serif-display text-2xl text-[#1C1C1C] mb-2">{v.title}</div>
              <p className="text-sm text-[#5C5C5C]">{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#A3133A] text-[#FBFBF9] relative grain">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 relative z-10">
          <div>
            <div className="text-[11px] tracking-eyebrow opacity-80 mb-4">Mission</div>
            <h3 className="font-serif-display text-4xl mb-5 leading-tight">Formare artisti consapevoli.</h3>
            <p className="opacity-90 leading-relaxed">
              Promuoviamo la cultura musicale come strumento di crescita
              personale e sociale. Ogni allievo è seguito in un percorso
              cucito sulle proprie attitudini, dal primo approccio alla
              certificazione internazionale.
            </p>
          </div>
          <div>
            <div className="text-[11px] tracking-eyebrow opacity-80 mb-4">Visione</div>
            <h3 className="font-serif-display text-4xl mb-5 leading-tight">L'arte come linguaggio comune.</h3>
            <p className="opacity-90 leading-relaxed">
              Creiamo una comunità in cui musica, teatro e performing arts
              dialogano. Saggi, concerti, masterclass e laboratori d'insieme
              sono parte integrante del percorso, non eventi accessori.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
